import { Controller }  from '@hotwired/stimulus'

export default class extends Controller {
  static classes = ['hidden']
  static targets = ['checkbox', 'radioButton', 'rootSelector']
  static values = { ids: Array }

  connect() {
    // Enable and show checkboxes if ids are present
    if (this.hasIdsValue) {
      this.enableMatchingCategories()
    } else {
      this.disableCheckboxes(this.checkboxTargets)
    }
  }

  enableMatchingCategories() {
    this.rootSelectorTargets.forEach(rootSelector => {
      let checkboxes = rootSelector.querySelectorAll("input[type=checkbox]")
      let ids = this.idsValue

      // check if any of the checkboxes has a value that is included in the ids array
      const result = Array.prototype.some.call(checkboxes, (checkbox) => {
        return ids.includes(checkbox.value)
      })

      // if any of the checkboxes has a value that is included in the ids array, show and enable the root selector and check the radio button
      if (result) {
        rootSelector.classList.remove(this.hiddenClass)
        let parentId = rootSelector.dataset.id

        // check the radio button that has the same parentId
        this.radioButtonTargets.forEach(radio => {
          if (radio.dataset.parentId == parentId) {
            radio.checked = true
          }
        })

        this.enableCheckboxes(checkboxes)
      } else {
        rootSelector.classList.add(this.hiddenClass)
        this.disableCheckboxes(checkboxes)
      }
    })
  }

  // Disable all children that are not child of checked parent
  handleCategorySelection(topLevelCategories, secondLevelCategories) {
    if (Array.from(topLevelCategories).some(checkbox => checkbox.checked) || Array.from(topLevelCategories).some(checkbox => checkbox.checked)) {
      const currentParent = Array.from(topLevelCategories).find(checkbox => checkbox.checked)
      const children = Array.from(secondLevelCategories).filter(checkbox => checkbox.dataset.parentId === currentParent.value && checkbox.checked)
      const otherChildren = Array.from(secondLevelCategories).filter(checkbox => checkbox.dataset.parentId !== currentParent.value)

      this.enableCheckboxes(children)
      this.disableCheckboxes(otherChildren)
    } else {
      // If no top level category is selected, enable all top level categories and disable all second level categories
      this.enableCheckboxes(topLevelCategories)
      this.disableCheckboxes(secondLevelCategories)
    }
  }

  toggleParentCheckboxes (event) {
    const parentId = event.params.id
    const rootSelectors = this.rootSelectorTargets

    rootSelectors.forEach(rootSelector => {
      if (rootSelector.dataset.id == parentId) {
        this.showAndEnableRootSelector(rootSelector)

        const topLevelCategories = rootSelector.querySelectorAll('input[type=checkbox][data-depth="1"]')
        const secondLevelCategories = rootSelector.querySelectorAll('input[type=checkbox][data-depth="2"]')
        const selectedTopLevelCategory = Array.from(topLevelCategories).filter(checkbox => checkbox.checked)

        // Disable all other top level categories when entering state
        if (selectedTopLevelCategory) {
          topLevelCategories.forEach(checkbox => {
            checkbox.disabled = checkbox !== selectedTopLevelCategory
          })
        }

        this.handleCategorySelection(topLevelCategories, secondLevelCategories)
      } else {
        this.hideAndDisableRootSelector(rootSelector)
      }
    })
  }

  showAndEnableRootSelector (rootSelector) {
    rootSelector.classList.remove(this.hiddenClass)
    let checkboxes = rootSelector.querySelectorAll("input[type=checkbox]")
    this.enableCheckboxes(checkboxes)
  }

  hideAndDisableRootSelector (rootSelector) {
    rootSelector.classList.add(this.hiddenClass)
    let checkboxes = rootSelector.querySelectorAll("input[type=checkbox]")
    this.disableCheckboxes(checkboxes)
  }

  disableCheckboxes(checkboxes) {
    checkboxes.forEach(checkbox => {
      checkbox.disabled = true
    })
  }

  enableCheckboxes(checkboxes) {
    checkboxes.forEach(checkbox => {
      checkbox.disabled = false
    })
  }
}
